// extracted by mini-css-extract-plugin
module.exports = {"root":"StepChip_root__BgrRu"};